import type { PassengerPricing, PricePassengerGroup } from '@massilia/queries'

/** Singular passenger type labels (e.g. price recap, sidebar) */
export const PASSENGER_TYPE_LABELS: Record<PassengerPricing['type'], string> = {
  Adult: 'Adulte',
  Child: 'Enfant',
  Infant: 'Bébé',
  Senior: 'Senior',
  Youngster: 'Jeune',
}

/** Plural passenger type labels (e.g. conditions modal) */
export const PASSENGER_TYPE_LABELS_PLURAL: Record<PricePassengerGroup['type'], string> = {
  Adult: 'Adultes',
  Child: 'Enfants',
  Infant: 'Bébés',
}
